import axiosInstance, { axiosInstanceCached, deleteCacheV3 } from '@/utils/axios';
import { handleApiError, deleteDataCache } from '@/utils/helpers';

// function mergeArrays(...arrays) {
//   let jointArray = [];
//   arrays.forEach(array => {
//     jointArray = [...jointArray, ...array];
//   });
//   return [...new Set([...jointArray])];
// }

// @ offset: number of entries to skip
// @ limit: number of entries to display
export const leaderboardList = async (payload) => {
  let response = {};
  try {
    response = await axiosInstanceCached.post(`/v3/stats_leaderboard_list`, payload, {
      id: `leaderboard_list`,
      cache: {
        ttl: 1000 * 60 * 30, // 30 minutes
      },
    });
    // console.log('leaderboard_list response:', response);
    // console.log('leaderboard_list cached:', response.cached);
    // console.log('leaderboard_list ttl:', response.config?.cache?.ttl);
    // console.log('leaderboard_list config:', response.config);
    // console.log('leaderboard_list duration:', response.duration);
    // console.log('============================');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ offset: number of entries to skip
// @ limit: number of entries to display
// export const globalStatsList = async (payload) => {
//   let response = {};
//   try {
//     // response = await axiosInstance.post(`/v3/global_stats_list`, payload);
//     response = {
//       status: 200,
//       data: mockGlobalStats,
//     };
//     return response;
//   } catch (error) {
//     return handleApiError(error);
//   }
// };

// // @  "user_id": user ID,
// // @  deleteCache: default false. Set to true to delete cache and query fresh data
// // @  "page_info": { Number of items to return?
// // @    "limit": 5
// // @  }
// export const userStatsList = async (payload) => {
//   console.log('userStatsList API payload:', payload);
//   let response = {};
//   const { deleteCache = false, user_id: id } = payload;
//   await deleteDataCache(axiosInstanceCached, deleteCache, `user_stats_${id}`);
//   try {
//     response = await axiosInstanceCached.post(
//       `/v3/user_stats_list`,
//       {
//         id: `user_stats_${id}`,
//         cache: {
//           ttl: 1000 * 60 * 2, // 2 minutes
//         },
//       },
//       payload
//     );
//     return response;
//   } catch (error) {
//     return handleApiError(error);
//   }
// };
